/**
 * version.js
 */

define(
        'version',
        ['jquery', "modal", 'bootstrap'],
        function ($, modal) {
            "use strict";

            /**
             * Afficher les informations de l'application
             */
            function showVersion()
            {
                var root = "";

                // Suppression du trop
                var origin = location.href.replace('#', '').toLowerCase();
                origin = origin.split("?")[0];
                origin = origin.replace("index.php", "");
                if (origin.endsWith('eservices/')) {
                    root = 'source/';
                }
                if (moduleType === 'ePortail') {
    root = "../../EServices/source/";
}
                modal.openModalIframe(root + "Information.php", "Informations");
            }

            //    exposed public method
            return {
                showVersion: showVersion
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);
